import { IMucThuKhacSinhVienSaveRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienSaveRequest";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { IMucThuKhacSinhVienSelectRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienSelectRequest";
import { IMucThuKhacSinhVienTheoLopSelectRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienTheoLopSelectRequest";
import { IMucThuKhacSinhVienUpdateSoTienRequest } from "../../model/request/chung-tu/IMucThuKhacSinhVienUpdateSoTienRequest";
import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IProcessRequest } from "../../model/request/IProcessRequest";
import { apiClient } from "../apiClient";
export const MUC_THU_KHAC_SINH_VIEN = "muc-thu-khac-sinh-vien";
export const mucThuKhacSinhVienApi = {
  SelectByLops: (request: IMucThuKhacSinhVienSelectByLopsRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-by-lops`, request),
  SelectVmByLops: (request: IMucThuKhacSinhVienSelectByLopsRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/selectvm-by-lops`, request),
  SelectByLopThuChi: (request: IMucThuKhacSinhVienTheoLopSelectRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-by-lop-thuchi`, request),
  SelectBySinhVien: (request: IMucThuKhacSinhVienSelectRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/select-by-sinhvien`, request),
  SelectKhoanThuSinhVien: (request: IMucThuKhacSinhVienSelectRequest) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/select-khoan-thu-sinhvien`,
      request
    ),
  Create: (request: IMucThuKhacSinhVienSaveRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}`, request),
  Deletes: (request: IIdsRequest) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/deletes`, request),
  UpdateSoTien: (request: IMucThuKhacSinhVienUpdateSoTienRequest) =>
    apiClient.put(`${MUC_THU_KHAC_SINH_VIEN}/so-tien`, request),
  DuyetAsync: (request: IProcessRequest<number[]>) =>
    apiClient.put(
      `${MUC_THU_KHAC_SINH_VIEN}/duyet?process_id=${request.process_id}`,
      request.payload
    ),
  HuyDuyetAsync: (request: IProcessRequest<number[]>) =>
    apiClient.put(
      `${MUC_THU_KHAC_SINH_VIEN}/huy-duyet?process_id=${request.process_id}`,
      request.payload
    ),

  Import: (request: FormData) =>
    apiClient.upload(`${MUC_THU_KHAC_SINH_VIEN}/import`, request),
  SaveImport: (request: string) =>
    apiClient.post(`${MUC_THU_KHAC_SINH_VIEN}/save-import/${request}`),

  ImportHuyDuyet: (request: FormData) =>
    apiClient.upload(`${MUC_THU_KHAC_SINH_VIEN}/import-huy-duyet`, request),
  SaveImportHuyDuyet: (request: string) =>
    apiClient.post(
      `${MUC_THU_KHAC_SINH_VIEN}/save-import-huy-duyet/${request}`
    ),
};
